export class Features {
  static readonly HomeShellId = '4593431b-e27a-4e91-a5f2-7f15af55658a';
  static readonly QuoteShellId = 'ae6cc829-06f7-4720-9542-90093497b617';
  static readonly OptionsShellId = '26573ab8-c505-4eda-92f4-0c2bfe6139c5';
  static readonly DetailsShellId = '6efd5962-310d-4cf4-a263-3294317e721b';
  static readonly PaymentShellId = '108514a3-48c0-4211-bd9b-ac30a7eb0896';
  static readonly ConfirmationShellId = '7a07f502-8815-4d60-bc7f-94acbfd86c30';
  static readonly ActivitiesId = '4e12875c-c46e-4b4d-b7b3-636fedef8dc5';
  static readonly HeaderId = 'a7112312-3461-4b34-b1d7-11d8b54defdb';
  static readonly FooterId = 'f5d75982-1da4-4422-9203-10ed932c1aa7';
  static readonly HeroId = 'ec8be554-ba79-11ea-b3de-0242ac130004';
  static readonly StepperId = '892bb271-4fd2-4674-a2ab-9eb53b127a78';
  static readonly QqcShellId = '4ce6f9e0-3d8f-4432-bda9-ca8e764ddb91';
  static readonly QqcTripTypeId = '1f051d36-0d87-4be7-a2d2-a8e242da134b';
  static readonly QqcDestinationId = '9bcaf06b-6c5e-4da9-b434-50e0cc5450d4';
  static readonly QqcTravelDatesId = 'be2df6fb-b929-4323-bb5b-2a1fa72a46ff';
  static readonly QqcTravellersAgeId = 'af0f73b0-1b7b-4044-8ec4-f8a7e5ddb23d';
  static readonly QqcPrivateInsuranceId =
    '3e497954-ba7c-11ea-b3de-0242ac130004';
  static readonly RewardPointsId = 'e1aee370-e3a9-11eb-ba80-0242ac130004';
  static readonly EmailQuoteId = '80f2d679-eed3-45a3-b625-32d05735255c';
  static readonly PromoCodeId = '53650d85-8b74-4c9a-9d23-a3cc7e7d7b65';
  static readonly TravelAlertId = 'bde0f8a3-e3b6-4f79-9571-73c8e309bb70';
  static readonly FootprintsId = '6a813233-9722-4c43-a597-339a9db7fee8';
  static readonly UserRegistrationId = '903e81e9-2308-4f77-9bb1-12fa7fb61c22';
  static readonly WinterSportTermsId = '666bfea3-a634-481f-a349-856d7e29562c';
  static readonly CookiesAlertId = '456f284e-42ad-46e4-b006-8a94ddc15531';
}
